import instance from '../axios'

/**
 * The caller's personal 1-10 rating rows (0.5 steps) - separate from the TMDB aggregate score.
 * Responses are camelCased by ASP.NET Core's default JSON policy
 * (only the first letter is lowercased: Ratings_Value -> ratings_Value).
 */
export type RatingItem = {
  ratings_Id: number
  ratings_UserId: number
  ratings_MediaType: 'Movie' | 'Show' | 'Episode'
  ratings_TmdbMediaId: number
  ratings_TmdbEpisodeId?: number | null
  ratings_SeasonNumber?: number | null
  ratings_EpisodeNumber?: number | null
  ratings_Value: number
}

// Request payloads keep PascalCase like the other *_api payload types
// (server-side model binding is case-insensitive).
export type UpsertRatingPayload = {
  Ratings_MediaType: 'Movie' | 'Show' | 'Episode'
  Ratings_TmdbMediaId: number
  Ratings_TmdbEpisodeId?: number
  Ratings_SeasonNumber?: number
  Ratings_EpisodeNumber?: number
  Ratings_Value: number
}

const ratingsApi = {
  // Caller's ratings for one media; for shows this includes its episode ratings.
  getForMedia: (mediaType: 'movie' | 'show', tmdbMediaId: number) =>
    instance.get<RatingItem[]>(`/ratings/media/${mediaType}/${tmdbMediaId}`),
  // One rating per (user, media, episode): creates or updates in place.
  upsert: (payload: UpsertRatingPayload) => instance.put<RatingItem>(`/ratings`, payload),
  delete: (ratingId: number) => instance.delete(`/ratings/${ratingId}`),
}

export default ratingsApi
